import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class ProductPackagesDataServiceProvider {
	updateProductPackageSubject: Subject<any> = new Subject();

	constructor(private http: HttpClient) {}

	getDefaultIntroductionText(): Observable<any> {
		const url = '/api/user/v1/quote/template';
		return this.http.get(url);
	}

	updateDefaultIntroductionText(
		id: number,
		textToUpdate: any
	): Observable<any> {
		const url = `/api/user/v1/quote/template/${id}`;
		return this.http.post(url, textToUpdate);
	}

	getPackagesOrProducts(pageRequest: any): Observable<any> {
		const url = '/api/user/v1/product/template/list';
		return this.http.post(url, pageRequest);
	}

	deletePackagesOrProducts(id: number): Observable<any> {
		const url = `/api/user/v1/product/template/${id}`;
		return this.http.delete(url);
	}

	createPackagesOrProducts(productOrPackage: any): Observable<any> {
		const url = '/api/user/v1/product/template';
		return this.http.post(url, productOrPackage);
	}

	updatePackagesOrProducts(id, productOrPackage: any): Observable<any> {
		const url = `/api/user/v1/product/template/${id}`;
		return this.http.post(url, productOrPackage);
	}

	getProductOrPackageTemplate(id: number): Observable<any> {
		const url = `/api/user/v1/product/template/${id}`;
		return this.http.get(url);
	}

	convertProductPackage(body: object): Observable<any> {
		const url = '/api/user/v1/product/template';
		return this.http.put(url, body);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/services/settings/product-packages.data.service.ts